import React, { useContext } from "react"
import { AuthContext } from "contexts/AuthContext"
import Avatar from "@mui/material/Avatar"

export default function UserAvatar(props) {
  const { userData } = useContext(AuthContext)
  return (
    <Avatar
      alt={userData.name}
      src={userData?.avatar}
      sx={{
        width: {
          xs: 25,
          md: 30,
        },
        height: {
          xs: 25,
          md: 30,
        },
      }}
      {...props}
    />
  )
}
